import React, { useState, useEffect } from "react";
import SweetAlert from "sweetalert2";

import {
  createVendorPayment,
  getBlock,
  getDistrict,
  getFY,
  getGPbyBlock,
  getPaymentData,
  getQuarterbyFY,
  getVenderData,
  VoucherUpload,
  dscChecker,
  getVendorAccountDetail,
  deductionTaxRate,
  dscSignature,
  getMajorheads,
  getMinorheads,
  getWorkTypes,
  getVendorDetail,
  validateDSC,
  uploadResolution,
} from "../../api/User";
import axios from "axios";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  MenuItem,
  Select,
} from "@material-ui/core";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import "../Invoice/VendorPaymentCreation.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import loader from "../../images/ajax-loader.gif";

import { SettingsVoice } from "@mui/icons-material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DSCValidationPage from "../DSCValidation";
import "../Admin/ProfilePage.css";
import pdfLogo from "../../images/logo192.png";
import { format } from "date-fns";

const VenderPaymentCreation = ({ token, userDetail, userData }) => {
  const [showTable, setShowTable] = useState(true);
  const [show, setShow] = useState(false);
  const [showITaxField, setShowITaxField] = useState(false);
  const [districtData, setDistrictData] = useState([]);
  const [districtType, setDistrictType] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockData, setBlockData] = useState([]);
  const [blockType, setBlockType] = useState("");
  const [GPType, setGPType] = useState("");
  const [GPData, setGPData] = useState([]);
  const [FYData, setFYData] = useState([]);
  const [fyType, setFyType] = useState([]);
  const [quarterByFY, setQuarterByFY] = useState([]);
  const [selectedQuarter, setSelectedQuarter] = useState("");
  const [quarterMonth, setQuarterMonth] = useState("");
  const [months, setMonths] = useState("");
  const [paymenAllocatedtData, setPaymentAllocatedData] = useState([]);
  const [paymentUsedData, setPaymentUsedData] = useState([]);
  const [paymentPendingData, setPaymentPendingData] = useState([]);
  const [totalNormal, setTotalNormal] = useState(0);
  const [totalSccp, setTotalSccp] = useState(0);
  const [totalRid, setTotalRid] = useState(0);
  const [totalAllocated, settotalAllocated] = useState(0);
  const [totalNormalUsed, settotalNormalUsed] = useState(0);
  const [totalSccpUsed, settotalSccpUsed] = useState(0);
  const [totalRidUsed, settotalRidUsed] = useState(0);
  const [totalUsed, settotalUsed] = useState(0);
  const [totalNormalPending, setTotalNormalPending] = useState(0);
  const [totalSccpPending, setTotalSccpPending] = useState(0);
  const [totalRidPending, setTotalRidPending] = useState(0);
  const [totalPending, settotalPending] = useState(0);

  const handleClose = () => {
    setShow(false);
  };
  const [venderData, setVenderData] = useState([]);
  const totalAvailable = totalAllocated - totalUsed;
  const [showDeduction, setShowDeduction] = useState(false);
  const [processingDate, setProcessingDate] = useState("");
  const [postingDate, setPostingDate] = useState("");
  const [approvalDate, setApprovalDate] = useState("");
  const [debitDetails, setDebitDetails] = useState({
    typeOfWork: "",
    vendorAmt: "",
    deductionAmt: 0,
    total: 0,
    narration: "",
  });

  const [creditDetails, setCreditDetails] = useState({
    typeOfWork: "",
    vendor: "",
    total: 0,
    narration: "",
  });
  const [currentNarration, setCurrentNarration] = useState("");
  const [securityChecked, setSecurityChecked] = useState(false);
  const [securityValue, setSecurityValue] = useState("");
  const [lcessChacked, setlcessChecked] = useState(false);
  const [lcessValue, setlcessValue] = useState("");
  const [lfedChacked, setlfedChecked] = useState(false);
  const [lfedValue, setlfedValue] = useState("");
  const [cgstChacked, setcgstChecked] = useState(false);
  const [cgstValue, setcgstValue] = useState("");
  const [sgstChacked, setsgstChecked] = useState(false);
  const [sgstValue, setsgstValue] = useState("");
  const [igstChacked, setigstChecked] = useState(false);
  const [igstValue, setigstValue] = useState("");
  const [itaxChacked, setitaxChecked] = useState(false);
  const [itaxValue, setitaxValue] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [isLimitAmntVisible, setIsLimitAmntVisible] = useState(false);
  const [deductions, setDeductions] = useState({
    security: { checked: false, value: "", percentage: "" },
    lcess: { checked: false, value: "", percentage: "" },
    lfed: { checked: false, value: "", percentage: "" },
    cgst: { checked: false, value: "", percentage: "" },
    sgst: { checked: false, value: "", percentage: "" },
    igst: { checked: false, value: "", percentage: "" },
    itax: { checked: false, value: "", percentage: "" },
  });
  const [deductionAmount, setDeductionAmount] = useState(0);
  const [vendorAmount, setVendorAmount] = useState(0);
  const [vendorAccountDetail, setVendorAccountDetail] = useState([]);
  const [voucher, setVoucher] = useState("");
  const [fileNo, setFileNo] = useState("");
  const [invoice, setInvoice] = useState("");
  const [securityTax, setSecurityTax] = useState([]);
  const [incomeTax, setIncomeTax] = useState([]);
  const [cgstTax, setCgstTax] = useState([]);
  const [sgstTax, setSgstTax] = useState([]);
  const [igstTax, setIgstTax] = useState([]);
  const [lCessTax, setLCessTax] = useState([]);
  const [lFedCessTax, setLFedCessTax] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dscFileName, setDscFileName] = useState("");
  const [quarterAuto, setQuarterAuto] = useState("");
  const [vendorDetails, setVendorDetails] = useState("");
  const [ischeckLImits, setIsChecklimits] = useState(false);

  if (token == null) {
    window.location.replace("http://localhost/govt-of-panchayat-sfc");
  }
  const [pdfFileName, setPdfFileName] = useState("");
  const MySwal = withReactContent(Swal);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const reloaded = urlParams.get("reloaded");

    if (!reloaded) {
      urlParams.set("reloaded", "true");
      window.history.replaceState(null, "", "?" + urlParams.toString());
      window.location.reload();
    }

    if (userDetail && role !== undefined) {
      setSchemeName(getSchemeName(role));
    }
    const getCurrentFinancialYear = () => {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;
      let q;
      if (currentMonth >= 4 && currentMonth <= 6) {
        setQuarterAuto("Q1");
        q = "Q1";
      } else if (currentMonth >= 7 && currentMonth <= 9) {
        setQuarterAuto("Q2");
        q = "Q2";
      } else if (currentMonth >= 10 && currentMonth <= 12) {
        setQuarterAuto("Q3");
        q = "Q3";
      } else if (currentMonth >= 1 && currentMonth <= 3) {
        setQuarterAuto("Q4");
        q = "Q4";
      }
      formData.quarter = q;
      if (currentMonth == 1) {
        setQuarterMonth("January");
      } else if (currentMonth == 2) {
        setQuarterMonth("February");
      } else if (currentMonth == 3) {
        setQuarterMonth("March");
      } else if (currentMonth == 4) {
        setQuarterMonth("April");
      } else if (currentMonth == 5) {
        setQuarterMonth("May");
      } else if (currentMonth == 6) {
        setQuarterMonth("June");
      } else if (currentMonth == 7) {
        setQuarterMonth("July");
      } else if (currentMonth == 8) {
        setQuarterMonth("August");
      } else if (currentMonth == 9) {
        setQuarterMonth("September");
      } else if (currentMonth == 10) {
        setQuarterMonth("October");
      } else if (currentMonth == 11) {
        setQuarterMonth("November");
      } else if (currentMonth == 12) {
        setQuarterMonth("December");
      }
      let startYear, endYear;
      if (currentMonth >= 5) {
        startYear = currentYear;
        endYear = currentYear + 1;
      } else {
        startYear = currentYear - 1;
        endYear = currentYear;
      }

      const endYearShort = endYear.toString().slice(-2);
      return `${startYear}-${endYearShort}`;
    };

    const fyYear = getCurrentFinancialYear();
    setFyType(fyYear);
    formData.fy = fyYear;
  }, []);

  const [visibleOptions, setVisibleOptions] = useState([]);
  const [isReadonlyEntity, setIsReadonlyEntity] = useState(false);
  const [isReadonlyDistrict, setIsReadonlyDistrict] = useState(false);
  const [isReadonlyBlock, setIsReadonlyBlock] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedValueName, setSelectedValueName] = useState("");
  const [loadingBlock, setLoadingBlock] = useState(false);
  const [blockName, setBlockName] = useState("");
  const role = userDetail?.role_id;
  const id = userDetail?.user_id;

  const [isSignPdfDisabled, setIsSignPdfDisabled] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [majorHeads, setMajorHeads] = useState([]);
  const [minorHeads, setMinorHeads] = useState([]);
  const [limitAmount, setLimitAmount] = useState(0);
  const [workTypes, setWorkTypes] = useState([]);
  const [workTypeName, setWorkTypeName] = useState([]);
  const [venderName, setVenderName] = useState([]);
  const [workTypeID, setWorkTypeID] = useState([]);
  const [majorHeadName, setMajorHeadName] = useState([]);
  const [minorHeadName, setMinorHeadName] = useState([]);
  const [DSCModalShow, setDSCModalShow] = useState(false);
  const handleDSCClose = () => setDSCModalShow(false);
  const [loadingNew, setLoadingNew] = useState(false);
  const [IGST, setIGST] = useState(true);
  const [CGST, setCGST] = useState(true);
  const [SGST, setSGST] = useState(true);
  const [s3Url, setS3Url] = useState("");
  const [ShowVenderPayment, setShowVenderPayment] = useState(false);
  useEffect(() => {
    const setCurrentDate = () => {
      const currentDate = new Date().toISOString().split("T")[0];
      setProcessingDate(currentDate);
      setApprovalDate(currentDate);
    };

    setCurrentDate();

    handleMajorHeads();
    handleWorkTypes();

    const options = [];

    if (role === 6 || role === 7) {
      options.push("gp");
      setSelectedValue("gp");
      setSelectedValueName("Gram Panchayat");
      setIsReadonlyEntity(true);
    } else if (role === 8 || role === 9) {
      options.push("ps");
      setSelectedValue("ps");
      setSelectedValueName("Panchayat Samiti");
      setIsReadonlyEntity(true);
    } else if (role === 10 || role === 11) {
      options.push("zp");
      setSelectedValue("zp");
      setSelectedValueName("Zila Parishad");
      setIsReadonlyEntity(true);
    } else {
      options.push("sab", "gp", "ps", "zp");
      setSelectedValue("");
      setIsReadonlyEntity(false);
    }
    setVisibleOptions(options);

    if (selectedValue) {
      handleEntityChange();
      if (role == 10) {
        handleFY();
      }
    }
    handleFY();
  }, [role, selectedValue]);

  const handleMajorHeads = async () => {
    try {
      await getMajorheads(token).then((res) => {
        if (res.status == "success") {
          setMajorHeads(res.data);
        }
      });
    } catch (err) {
      console.log(err);
    }
  };
  const handleMajorHead = async (e) => {
    if (e.target.value != "") {
      setValidationState((prevState) => ({
        ...prevState,
        validationMajorHead: true,
      }));
    } else {
      setValidationState((prevState) => ({
        ...prevState,
        validationMajorHead: false,
      }));
    }
    formData.major_head = e.target.value;
    const selectedIndex =
      e.target.options[e.target.selectedIndex].getAttribute("data-index");
    // console.log(
    //   majorHeads.length > 0
    //     ? majorHeads[selectedIndex].nomenclature_of_major_head
    //     : ""
    // );
    setMajorHeadName(
      majorHeads.length > 0
        ? `${majorHeads[selectedIndex].nomenclature_of_major_head}-${majorHeads[selectedIndex].major_head}`
        : ""
    );
    // console.log(selectedIndex);
    const data = {
      major_head: e.target.value,
    };
    try {
      await getMinorheads(token, data).then((res) => {
        if (res.status == "success") {
          setMinorHeads(res.data);
        }
      });
    } catch (error) {}
  };

  const fetchDistrictData = async () => {
    try {
      const res = await getDistrict(
        token,
        userDetail.role_id,
        userDetail.user_id
      );
      setDistrictData(res.data);

      if (
        res.data.length > 0 &&
        (role === 6 ||
          role === 7 ||
          role === 8 ||
          role === 9 ||
          role === 10 ||
          role === 11)
      ) {
        setIsChecklimits(true);

        setDistrictType(res.data[0].district_code);
        setDistrictName(res.data[0].district_name);
        fetchBlockData(res.data[0].district_code);
        formData.district = res.data[0].district_code;
        setIsReadonlyDistrict(true);
        if(res.data.length > 1) {
          setIsReadonlyDistrict(false)
        }
      }
    } catch (error) {
      console.error("Error fetching district data:", error);
    }
  };

  const fetchBlockData = async (districtCode) => {
    const data = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district: districtCode,
    };

    try {
      const res = await getBlock(token, data);
      setBlockData(res.user);
      if (res.user.length == 1) {
        setIsChecklimits(true);
        setBlockType(res.user[0].block_code);
        setBlockName(res.user[0].block_name);
        setIsReadonlyBlock(true);
        fetchVillageData(res.user[0].block_code, data.district);
        formData.block = res.user[0].block_code;
      } else if (res.user.length > 1) {
        setIsReadonlyBlock(false);
      }
    } catch (error) {
      console.error("Error fetching block data:", error);
    }
  };

  const fetchVillageData = async (blockcode, district_code) => {
    const data1 = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district_code: district_code,
      block_code: blockcode,
    };

    try {
      await getGPbyBlock(token, data1)
        .then((res) => {
          setGPData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching block data:", error);
    }
  };

  const handleEntityChange = async (e) => {
    const newValue = e?.target?.value || selectedValue;

    setSelectedValue(newValue);
    await fetchDistrictData();
  };

  useEffect(() => {
    if (selectedValue) {
      handleEntityChange();
    }
  }, [selectedValue]);

  const handleDistrictChange = async (e) => {
    setIsChecklimits(true);
    setDistrictType(e.target.value);
    formData.district = e.target.value;
    const data = {
      role: userDetail?.role_id,
      id: userDetail.user_id,
      district: e.target.value,
    };

    try {
      await getBlock(token, data)
        .then((res) => {
          setBlockData(res.user);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleBlockChange = async (e) => {
    setIsChecklimits(true);
    setBlockType(e.target.value);
    formData.block = e.target.value;

    const data = {
      role_id: userDetail?.role_id,
      id: userDetail.user_id,
      district_code: districtType,
      block_code: e.target.value,
    };

    try {
      await getGPbyBlock(token, data)
        .then((res) => {
          setGPData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    if (role == 8) {
      handleFY();
    }
  };
  const handleGPChange = (e) => {
    setIsChecklimits(true);
    setGPType(e.target.value);
    formData.village = e.target.value;
    const village = e.target.value;

    handleFY();
  };

  const handleFY = async (e) => {
    const data = {
      // fy: fyType,
      fy: "2023-24",
    };

    try {
      await getQuarterbyFY(token, data)
        .then((res) => {
          setQuarterByFY(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleMonthChange = (e) => {
    setMonths(e.target.value);
    formData.months = e.target.value;
  };
  const [validationState, setValidationState] = useState({
    validationCheckLimits: false,
    validationMajorHead: false,
    validationMinorHead: false,
    validationUseLimit: false,
    validationTypeofWork: false,
    validationVendorAmount: false,
    validationNarration: false,
    validationPostingDate: false,
    validationVendor: false,
    validationFileNo: false,
    validationInvoiceNo: false,
    validationVoucherUpload: false,
  });
  const handleCheckLimits = async (e) => {
    setValidationState((prevState) => ({
      ...prevState,
      validationCheckLimits: true,
    }));
    setShowPaymentConsentModal(false);
    generateFileName();
    setLoading(true);
    e.preventDefault();
    setIsVisible(true);
    const data = {
      role_id: userDetail?.role_id,
      district_code: districtType,
      block_code: blockType,
      village_code: GPType,
      fy: fyType,
      quarter: selectedQuarter,
    };
    const data2 = {
      district: districtType,
      block: blockType,
      village: GPType,
      role: userDetail?.role_id,
    };

    try {
      await getPaymentData(token, data)
        .then((res) => {
          setPaymentAllocatedData(res.data.result_allocated);
          setPaymentUsedData(res.data.result_used);
          setPaymentPendingData(res.data.result_pending);
          setShowPaymentConsentModal(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    try {
      await getVenderData(token, data2)
        .then((res) => {
          setVenderData(res.user);
          setShowPaymentConsentModal(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const [totalAmount, setTotalAmount] = useState("");
  useEffect(() => {
    const sumNormal = paymenAllocatedtData.reduce((acc, row) => {
      return acc + (row.normal || 0);
    }, 0);
    setTotalNormal(sumNormal);
    const sumSccp = paymenAllocatedtData.reduce((acc, row) => {
      return acc + (row.sccp || 0);
    }, 0);
    setTotalSccp(sumSccp);
    const sumRid = paymenAllocatedtData.reduce((acc, row) => {
      return acc + (row.rid || 0);
    }, 0);
    setTotalRid(sumRid);

    const sumAllocated = paymenAllocatedtData.reduce((acc, row) => {
      return acc + (row.normal || 0) + (row.sccp || 0) + (row.rid || 0);
    }, 0);
    settotalAllocated(sumAllocated);

    const sumNormalUsed = paymentUsedData.reduce((acc, row) => {
      return acc + (row.normal || 0);
    }, 0);
    settotalNormalUsed(sumNormalUsed);

    const sumSccpUsed = paymentUsedData.reduce((acc, row) => {
      return acc + (row.sccp || 0);
    }, 0);
    settotalSccpUsed(sumSccpUsed);

    const sumRidUsed = paymentUsedData.reduce((acc, row) => {
      return acc + (row.rid || 0);
    }, 0);
    settotalRidUsed(sumRidUsed);

    const sumUsed = paymentUsedData.reduce((acc, row) => {
      return acc + (row.normal || 0) + (row.sccp || 0) + (row.rid || 0);
    }, 0);
    settotalUsed(sumUsed);
    const sumNormalPending = paymentPendingData.reduce((acc, row) => {
      return acc + (row.normal || 0);
    }, 0);
    setTotalNormalPending(sumNormalPending);
    const sumSccpPending = paymentPendingData.reduce((acc, row) => {
      return acc + (row.sccp || 0);
    }, 0);
    setTotalSccpPending(sumSccpPending);
    const sumRidPending = paymentPendingData.reduce((acc, row) => {
      return acc + (row.rid || 0);
    }, 0);
    setTotalRidPending(sumRidPending);
    const sumAllocatedPending = paymentPendingData.reduce((acc, row) => {
      return acc + (row.normal || 0) + (row.sccp || 0) + (row.rid || 0);
    }, 0);
    settotalPending(sumAllocatedPending);
    setTotalAmount(sumAllocated - (sumUsed + sumAllocatedPending));
    if (sumAllocated - (sumUsed + sumAllocatedPending) < 0) {
      MySwal.fire({
        icon: "warning",
        title: "Alert",
        text: "You have over-used your Limits, Please wait for next limit allocation",
      });
    }
  }, [paymenAllocatedtData, paymentUsedData, paymentPendingData]);

  const cellStyle = {
    border: "1px solid black",
    whiteSpace: "nowrap",
    fontSize: "16px",
  };

  const handlePostingDate = (e) => {
    setPostingDate(e.target.value);
    if (e.target.value != "") {
      setValidationState((prevState) => ({
        ...prevState,
        validationPostingDate: true,
      }));
    } else {
      setValidationState((prevState) => ({
        ...prevState,
        validationPostingDate: false,
      }));
    }
    formData.posting_date = e.target.value;
    // console.log(" formData posting_date", formData.posting_date);
  };

  const handleDeductionChange = (e) => {
    if(e.target.value == "No"){
       setCardetails(true);
       formData.payment_amount = debitDetails.vendorAmt;
    }
    setShowDeduction(e.target.value === "Yes");
    formData.deduction_applied = e.target.value;

    if (e.target.value === "Yes") {
      getAllTaxes(e);
    } else {
      setSecurityValue("");
      setlcessValue("");
      setlfedValue("");
      setcgstValue("");
      setsgstValue("");
      setigstValue("");
      setitaxValue("");
    }
  };

  const getAllTaxes = async (e) => {
    try {
      await deductionTaxRate(token)
        .then((res) => {
          if (res.status == "success") {
            setSecurityTax(res.data[5].tax_rate);
            setLFedCessTax(res.data[4].tax_rate);
            setLCessTax(res.data[3].tax_rate);
            setSgstTax(res.data[6].tax_rate);
            setIgstTax(res.data[1].tax_rate);
            setCgstTax(res.data[0].tax_rate);
            setIncomeTax(res.data[2].tax_rate);
            if (!e.target.checked) {
              setSecurityValue(0);
            }
          }
        })
        .catch((err) => {
          console.log("Error fetching Tax data:", err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSecurityCheckboxChange = async (e) => {
    debitDetails.deductionAmt = 0;
    setCardetails(false);
    setSecurityChecked(e.target.checked);
    handleSecuritySelectChange(e.target.checked);
  };

  const handlelcessCheckboxChange = async (e) => {
    debitDetails.deductionAmt = 0;
    setCardetails(false);
    setlcessChecked(e.target.checked);
    handlelcessSelectChange(e.target.checked);
  };

  const handlelfedCheckboxChange = async (e) => {
    debitDetails.deductionAmt = 0;
    setCardetails(false);
    setlfedChecked(e.target.checked);
    handlelfedSelectChange(e.target.checked);
  };

  const handlecgstCheckboxChange = async (e) => {
    debitDetails.deductionAmt = 0;
    setCardetails(false);
    setIGST((prevState) => !prevState);
    setcgstChecked(e.target.checked);
    handlecgstSelectChange(e.target.checked);
  };

  const handlesgstCheckboxChange = async (e) => {
    debitDetails.deductionAmt = 0;
    setCardetails(false);
    setsgstChecked(e.target.checked);
    handlesgstSelectChange(e.target.checked);
  };

  const handleigstCheckboxChange = async (e) => {
    debitDetails.deductionAmt = 0;
    setCardetails(false);
    setCGST((prevState) => !prevState);
    setSGST((prevState) => !prevState);
    setigstChecked(e.target.checked);

    handleigstSelectChange(e.target.checked);
  };

  const handleitaxCheckboxChange = async (e) => {
    debitDetails.deductionAmt = 0;
    setCardetails(false);
    setitaxChecked(e.target.checked);
    handleitaxSelectChange(e.target.checked);
  };
  const handleSecuritySelectChange = async (check) => {
    let security = parseInt(securityTax);
    if (check == true) {
      console.log("true hai");
      setSecurityValue(parseInt(debitDetails.vendorAmt * (securityTax / 100)));
      setTotalDeductions((prev) => {
        return {
          ...prev,
          security: parseInt(debitDetails.vendorAmt * (securityTax / 100)),
        };
      });
    } else {
      console.log("false hai");
      setTotalDeductions((prev) => {
        return {
          ...prev,
          security: 0,
        };
      });

      setSecurityValue(0);
      // securityValue
      formData.security = 0;
    }
  };

  const handlelcessSelectChange = (check) => {
    console.log(totalDeductions, "total deduct");
    let lcess = parseInt(lCessTax);
    if (check == true) {
      setlcessValue(parseInt(debitDetails.vendorAmt * (lCessTax / 100)));
      formData.labor_cess = parseInt(debitDetails.vendorAmt * (lCessTax / 100));

      setTotalDeductions((prev) => {
        return {
          ...prev,
          lcess: parseInt(debitDetails.vendorAmt * (lCessTax / 100)),
        };
      });
    } else {
      setTotalDeductions((prev) => {
        return {
          ...prev,
          lcess: 0,
        };
      });
      setlcessValue(0);
      formData.labor_cess = 0;
      debitDetails.deductionAmt = 0;
    }
  };

  const handlelfedSelectChange = (check) => {
    console.log(totalDeductions, "total deduct");
    let lfed = parseInt(lFedCessTax);
    if (check == true) {
      setlfedValue(parseInt(debitDetails.vendorAmt * (lFedCessTax / 100)));
      formData.lfed = parseInt(debitDetails.vendorAmt * (lFedCessTax / 100));
      setTotalDeductions((prev) => {
        return {
          ...prev,
          lfed: parseInt(debitDetails.vendorAmt * (lFedCessTax / 100)),
        };
      });
    } else {
      setlfedValue(0);
      setTotalDeductions((prev) => {
        return {
          ...prev,
          lfed: 0,
        };
      });
      formData.lfed = 0;
      debitDetails.deductionAmt = 0;
    }
  };

  const handlecgstSelectChange = (check) => {
    let cgst = parseInt(cgstTax);
    if (check == true) {
      setcgstValue(parseInt(debitDetails.vendorAmt * (cgstTax / 100)));
      formData.cgst = parseInt(debitDetails.vendorAmt * (cgstTax / 100));
      setTotalDeductions((prev) => {
        return {
          ...prev,
          cgst: parseInt(debitDetails.vendorAmt * (cgstTax / 100)),
        };
      });
    } else {
      setcgstValue(0);
      setTotalDeductions((prev) => {
        return {
          ...prev,
          cgst: 0,
        };
      });
      formData.cgst = 0;
      debitDetails.deductionAmt = 0;
    }
  };

  const handlesgstSelectChange = (check) => {
    let sgst = parseInt(sgstTax);
    if (check == true) {
      setsgstValue(parseInt(debitDetails.vendorAmt * (sgstTax / 100)));
      formData.sgst = parseInt(debitDetails.vendorAmt * (sgstTax / 100));
      setTotalDeductions((prev) => {
        return {
          ...prev,
          sgst: parseInt(debitDetails.vendorAmt * (sgstTax / 100)),
        };
      });
    } else {
      setsgstValue(0);
      setTotalDeductions((prev) => {
        return {
          ...prev,
          sgst: 0,
        };
      });
      formData.sgst = 0;
      debitDetails.deductionAmt = 0;
    }
  };

  const handleigstSelectChange = (check) => {
    let igst = parseInt(igstTax);
    if (check == true) {
      setigstValue(parseInt(debitDetails.vendorAmt * (igstTax / 100)));
      formData.igst = parseInt(debitDetails.vendorAmt * (igstTax / 100));
      setTotalDeductions((prev) => {
        return {
          ...prev,
          igst: parseInt(debitDetails.vendorAmt * (igstTax / 100)),
        };
      });
    } else {
      setigstValue(0);
      setTotalDeductions((prev) => {
        return {
          ...prev,
          igst: 0,
        };
      });
      formData.igst = 0;
      debitDetails.deductionAmt = 0;
    }
  };

  const handleitaxSelectChange = (check) => {
    let itax = parseInt(incomeTax);
    if (check == true) {
      setitaxValue(parseInt(debitDetails.vendorAmt * (incomeTax / 100)));
      formData.income_tax_rs = parseInt(
        debitDetails.vendorAmt * (incomeTax / 100)
      );
      setTotalDeductions((prev) => {
        return {
          ...prev,
          itax: parseInt(debitDetails.vendorAmt * (incomeTax / 100)),
        };
      });
    } else {
      setitaxValue(0);
      setTotalDeductions((prev) => {
        return {
          ...prev,
          itax: 0,
        };
      });
      formData.income_tax_rs = 0;
      debitDetails.deductionAmt = 0;
    }
  };

  const handleVendorAmtChange = (e) => {
    // console.log(vendorAmt)
    if (e.target.value != "") {
      setValidationState((prevState) => ({
        ...prevState,
        validationVendorAmount: true,
      }));
    } else {
      setValidationState((prevState) => ({
        ...prevState,
        validationVendorAmount: false,
      }));
    }
    const inputValue = e.target.value;
    let vendorAmt = inputValue == "" ? "" : parseInt(inputValue);
    setVendorAmount(vendorAmt);
    console.log(vendorAmt);
    // Reset values when clearing the input
    if (inputValue === "" || isNaN(vendorAmt)) {
      setDebitDetails((prevDetails) => ({
        ...prevDetails,
        vendorAmt: "",
        total: 0,
      }));
      formData.vendor_amount = "";
      handleCalulateDeduction();
      return;
    }

    formData.vendor_amount = vendorAmt;
    console.log(totalAmount);
    console.log(limitAmount);
    if (vendorAmt > limitAmount) {
      const message =
        vendorAmt > limitAmount
          ? "Please enter a valid amount within the limit."
          : "Please enter a valid amount within the Total limit.";

      SweetAlert.fire({
        icon: "error",
        title: "Vendor Amount Exceed Limit",
        text: message,
      }).then(() => {
        setDebitDetails((prevDetails) => ({
          ...prevDetails,
          vendorAmt: "",
          total: 0,
        }));
        formData.vendor_amount = "";
      });
    } else {
      setDebitDetails((prevDetails) => ({
        ...prevDetails,
        vendorAmt,
      }));
      console.log("vendor amnt", vendorAmt);
    }
  };

  const [totalDeductions, setTotalDeductions] = useState([
    {
      security: 0,
      lcess: 0,
      lfed: 0,
      cgst: 0,
      sgst: 0,
      igst: 0,
      itax: 0,
    },
  ]);

  // const calculateDeductionAmt = (vendorAmt = debitDetails.vendorAmt) => {
  //   console.log(securityValue)
  //   const toatldecuctionAmount =
  //     (securityChecked ? securityValue : 0) +
  //     (lcessChacked ? lcessValue : 0) +
  //     (lfedChacked ? lfedValue : 0) +
  //     (cgstChacked ? cgstValue : 0) +
  //     (sgstChacked ? sgstValue : 0) +
  //     (igstChacked ? igstValue : 0) +
  //     (itaxChacked ? itaxValue : 0);
  //   //  setTotalDeductions((securityChecked ? securityValue : 0) +
  //   //   (lcessChacked ? lcessValue : 0) +
  //   //   (lfedChacked ? lfedValue : 0) +
  //   //   (cgstChacked ? cgstValue : 0) +
  //   //   (sgstChacked ? sgstValue : 0) +
  //   //   (igstChacked ? igstValue : 0) +
  //   //   (itaxChacked ? itaxValue : 0));
  //   const total = vendorAmt - toatldecuctionAmount;
  //   formData.payment_amount = total;
  //   console.log("total decutions", toatldecuctionAmount);
  //   debitDetails.deductionAmt = toatldecuctionAmount;

  //   setDebitDetails((prevDetails) => ({
  //     ...prevDetails,
  //     deductionAmt: toatldecuctionAmount,
  //     total,
  //   }));
  // };
  const handleNarrationChange = (event) => {
    if (event.target.value != "" || null) {
      setValidationState((prevState) => ({
        ...prevState,
        validationNarration: true,
      }));
    } else {
      setValidationState((prevState) => ({
        ...prevState,
        validationNarration: false,
      }));
    }
    const narration = event.target.value;
    setDebitDetails({ ...debitDetails, narration });
    setCreditDetails({ ...creditDetails, narration });
    formData.narration = narration;
  };
  const [resolution, setResolution] = useState(null);
  const handleFile = (event) => {
    setResolution(event.target.files[0]);
    // console.log(event.target.files[0])
    if (event.target.files[0] != undefined) {
      setValidationState((prevState) => ({
        ...prevState,
        validationVoucherUpload: true,
      }));
    } else {
      setValidationState((prevState) => ({
        ...prevState,
        validationVoucherUpload: false,
      }));
    }
  };
  const [formData, setFormData] = useState({
    dscFileName: "",
    filename: "",
    district: "",
    block: "",
    village: "",
    quarter: "",
    fy: "",
    months: "",
    posting_date: "",
    processing_date: "",
    scheme: "",
    deduction_applied: "No",
    deduction_amount: deductionAmount,
    maker_name: id,
    revenue_capital: "",
    type_of_work: "",
    vendor_amount: "",
    security: 0,
    income_tax_rs: 0,
    labor_cess: 0,
    labor_fed_cess: 0,
    cgst: 0,
    sgst: 0,
    igst: 0,
    payment_amount: "",
    narration: "",
    limit_type: "",
    remaining_balance: "",
    work_id: "",
    file_no: "",
    approval_date: "",
    invoice_no: "",
    invoice_date: "",
    vendor_id: "",
    head_type: "Payable",
    major_head: "",
    minor_head: "",
    location: "",
    role_id: role,
    work_name: "",
    vendor_name: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSub = async (e) => {
    setIsSubmitDisabled(true);
    formData.processing_date = processingDate;
    formData.approval_date = approvalDate;
    formData.invoice_date = approvalDate;

    // console.log("formData", formData);
    e.preventDefault();

    try {
      const res = await createVendorPayment(token, formData);
      if (res.status == "success") {
        const resolutionData = new FormData();
        resolutionData.append("resolution", resolution);
        resolutionData.append("village", GPType);
        resolutionData.append("block", blockType);
        resolutionData.append("district", districtType);
        resolutionData.append("sanction_id", res.sanction);

        const resp = await uploadResolution(token, resolutionData);
        MySwal.fire({
          icon: res.status,
          title: res.status,
          text: res.message,
        }).then((resp) => {
          window.location.reload();
        });
      } else {
        console.error(
          "Failed to create Payment:",
          res ? res.message : "Unknown error"
        );
        MySwal.fire({
          icon: "error",
          title: "Error",
          title: "Failed to create Payment...!!",
        }).then(() => {
          window.location.reload();
        });
      }
    } catch (error) {
      console.error("Error creating Payment:", error);
    }
  };
  const formatDate = (date) => {
    if (!date) return "";
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleDateString(undefined, options);
  };

  const handleSubmit = async (e) => {
    setLoadingNew(true);
    // console.log("UserDetails==>>>>", userData);
    e.preventDefault();
    try {
      const pdfBlob = exportPDF(formData);
      // console.log(pdfBlob);
      const formDataForUpload = createFormData(pdfBlob, pdfFileName);
      // console.log(formDataForUpload);
      const res = await VoucherUpload(token, formDataForUpload);
      // console.log(res);
      if (res.status == "success") {
        const pdfFile = pdfFileName.split(".");
        setS3Url(
          `https://sfc-account-module.s3.ap-south-1.amazonaws.com/uploads/${pdfFile[0]}_maker_signed.pdf`
        );
        // console.log(
        //   `https://sfc-account-module.s3.ap-south-1.amazonaws.com/uploads/${pdfFile[0]}_maker_signed.pdf`
        // );
        // console.log("FileName---....", pdfFileName);

        fetch(`http://localhost:9196/signPdf/1/12345678/${dscFileName}/maker`)
          .then((data) => {
            // console.log(data);

            return data.text();
          })
          .then((res) => {
            // console.log("data", res);
            if (res.indexOf("maker_signed") !== -1) {
              setLoadingNew(false);
              MySwal.fire({
                icon: "success",
                title: "PDF signed Successfully!!",
              }).then(() => {
                setIsSubmitDisabled(false);
                setIsSignPdfDisabled(true);
                window.open(
                  `https://sfc-account-module.s3.ap-south-1.amazonaws.com/uploads/${pdfFile[0]}_maker_signed.pdf`,
                  "_blank"
                );
              });
            } else {
              // console.log(res);
            }
          });
      } else {
        MySwal.fire({
          icon: "warning",
          title: "Error Signing the PDF",
        });
        setLoadingNew(false);
      }
      // }
    } catch (err) {
      console.error("Error uploading voucher:", err);
      MySwal.fire({
        icon: "warning",
        title: "Error the PDF",
      });
      setLoadingNew(false);
    }
  };

  // useEffect(() => {
  //   if (
  //     securityValue !== 0 ||
  //     lcessValue !== 0 ||
  //     lfedValue !== 0 ||
  //     cgstValue !== 0 ||
  //     sgstValue !== 0 ||
  //     igstValue !== 0 ||
  //     itaxValue !== 0
  //   ) {
  //     calculateDeductionAmt();
  //   }
  // }, [
  //   securityValue,
  //   lcessValue,
  //   lfedValue,
  //   cgstValue,
  //   sgstValue,
  //   igstValue,
  //   itaxValue,
  // ]);

  const exportPDF = (data) => {
    const doc = new jsPDF("portrait", "pt", "A4");

    const logoUrl = pdfLogo;
    doc.addImage(logoUrl, "PNG", 36, 6, 36, 40);
    // console.log(limitAmount);
    const tableData = [
      ["Type of Transaction", "Online"],
      ["Scheme Name", schemeName],
      ["Work Type", workTypeName],
      ["Sanctioned Amount", limitAmount],
      ["DNIT/Agreement Amount", debitDetails.vendorAmt],
      ["Voucher No", voucher],
      ["Expenditure Major Head", majorHeadName],
      ["Expenditure Minor Head", minorHeadName],
      ["To whom Paid (Vendor Name)", venderName],
      ["Remarks", creditDetails.narration],
      // ["Mode of Payment", ""],
      [
        "Payee Account Number",
        vendorDetails[0]?.account_number
          ? vendorDetails[0]?.account_number
          : "0",
      ],
    ];
    // console.log(tableData);
    const margin = 20;
    const pageWidth = 500;
    const tableWidth = pageWidth / 2;

    doc.setFontSize(16);
    const titleText = "Payment Voucher";

    const titleWidth =
      (doc.getStringUnitWidth(titleText) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const titleX = (doc.internal.pageSize.getWidth() - titleWidth) / 2;
    doc.text(titleText, titleX, 40);

    doc.autoTable({
      startY: 60,
      body: tableData,
      theme: "grid",
      columnStyles: {
        0: { cellWidth: tableWidth },
        1: { cellWidth: tableWidth },
      },
      styles: {
        cellPadding: 5,
        fontSize: 12,
        valign: "middle",
        lineWidth: 0.1,
      },
    });

    doc.setFontSize(12);
    const totalBillText = `Total Bill Amount: ${
      debitDetails.total ? debitDetails.total : " 0 "
    }`;
    const totalBillWidth =
      (doc.getStringUnitWidth(totalBillText) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const totalBillX = 40;
    const totalBillY = doc.autoTable.previous.finalY + 20;
    doc.text(totalBillText, totalBillX, totalBillY + 5);

    const deductionsData = [
      ["Security Rs.", `${securityValue}`],
      ["Income Tax Rs.", `${itaxValue}`],
      ["Labor Cess Rs", `${lcessValue}`],
      ["Labor Fed Cess Rs.", `${lfedValue}`],
      ["CGST Rs.", `${cgstValue}`],
      ["SGST Rs", `${sgstValue}`],
      ["IGST Rs.", `${igstValue}`],
      ["Total Deduction", `${debitDetails.deductionAmt}`],
    ];

    doc.autoTable({
      startY: doc.autoTable.previous.finalY + 30,
      body: deductionsData,
      theme: "grid",
      columnStyles: {
        0: { cellWidth: tableWidth },
        1: { cellWidth: tableWidth },
      },
      styles: {
        cellPadding: 5,
        fontSize: 12,
        valign: "middle",
        lineWidth: 0.1,
      },
    });

    doc.setFontSize(12);
    const netPayText = `Net Pay to Vendor = (${
      debitDetails.vendorAmt ? debitDetails.vendorAmt : " 0 "
    } - ${debitDetails.deductionAmt ? debitDetails.deductionAmt : " 0 "}) = ${
      debitDetails.vendorAmt - debitDetails.deductionAmt
    }`;
    const netPayTextWidth =
      (doc.getStringUnitWidth(netPayText) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const netPayTextX = 40;
    const netPayTextY = doc.autoTable.previous.finalY + 20;
    doc.text(netPayText, netPayTextX, netPayTextY + 5);

    doc.setFontSize(12);
    const payText = `Pay Rs ${
      debitDetails.total ? debitDetails.total : " 0 "
    } by voucher No ${voucher ? voucher : " 0 "}`;
    const payTextWidth = pageWidth;
    const payTextX = 40;
    const payTextY = doc.autoTable.previous.finalY + 40;
    doc.text(payText, payTextX, payTextY + 5);

    doc.setFontSize(12);
    const dateText = "Dated:-";
    const dateTextWidth =
      (doc.getStringUnitWidth(dateText) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const dateTextX = 40;
    const dateTextY = doc.autoTable.previous.finalY + 60;
    doc.text(dateText, dateTextX, dateTextY + 5);

    doc.setFontSize(15);
    const DSCMaker = "DSC of Maker";
    const DSCMakerWidth =
      (doc.getStringUnitWidth(DSCMaker) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const DSCMakerX = 50;
    const DSCMakerY = doc.autoTable.previous.finalY + 200;
    doc.text(DSCMaker, DSCMakerX, DSCMakerY + 5);

    doc.setFontSize(15);
    const DSCChecker = "DSC of Checker";
    const DSCCheckerWidth =
      (doc.getStringUnitWidth(DSCChecker) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const DSCCheckerX = 420;
    const DSCCheckerY = doc.autoTable.previous.finalY + 200;
    doc.text(DSCChecker, DSCCheckerX, DSCCheckerY + 5);

    return doc.output("blob");
  };
  const generateFileName = () => {
    const min = 100000;
    const max = 999999;
    let no = Math.floor(Math.random() * (max - min + 1)) + min;
    const newFilename = "Voucher_" + no + ".pdf";
    const dscFileName = "Voucher_" + no;
    formData.filename = newFilename;
    formData.dscFileName = dscFileName;
    setPdfFileName(newFilename);
    setDscFileName(dscFileName);
  };
  const createFormData = (pdfBlob, name) => {
    const formData = new FormData();
    formData.append("dsc_file", pdfBlob, name);
    return formData;
  };

  const [cardDetails, setCardetails] = useState(false);

  const handleCalulateDeduction = () => {
    console.log("total deduction in calculate functin", totalDeductions);
    setCardetails(true);
    const calculateTotalDeductions = () => {
      return (
        (totalDeductions.security || 0) +
        (totalDeductions.lcess || 0) +
        (totalDeductions.lfed || 0) +
        (totalDeductions.cgst || 0) +
        (totalDeductions.sgst || 0) +
        (totalDeductions.igst || 0) +
        (totalDeductions.itax || 0)
      );
    };

    const deduction = calculateTotalDeductions();
    const total = debitDetails.vendorAmt - deduction;
    formData.payment_amount = total;
    console.log("Deduction is: -----", deduction);

    debitDetails.deductionAmt = deduction;
    setDebitDetails((prevDetails) => ({
      ...prevDetails,
      deductionAmt: deduction,
      total,
    }));
  };

  const handleVendorChange = (e, deduct) => {
    console.log(
      totalDeductions,
      "total deduct lastttttttttttttttttttttttttttttttttttttttttttttttttttt"
    );

    if (e.target.value != "") {
      setValidationState((prevState) => ({
        ...prevState,
        validationVendor: true,
      }));
    } else {
      setValidationState((prevState) => ({
        ...prevState,
        validationVendor: false,
      }));
    }
    // setAccountNumber(ac_no);
    setVendorDetails(
      venderData.filter((data) => {
        return data.vendor_id === e.target.value;
      })
    );
    setDeductionAmount(deduct);
    formData.vendor_id = e.target.value;
    handleVenderName(e);
  };
  const [schemeName, setSchemeName] = useState("");

  // useEffect(() => {
  //   if (userDetail && role !== undefined) {
  //     setSchemeName(getSchemeName(role));
  //   }
  // }, [userDetail]);

  const getSchemeName = (role) => {
    if (role == 6 || role == 7) {
      formData.scheme = "gp";
      return "Gram Panchayat";
    }
    if (role == 8) {
      formData.scheme = "ps";
      return "Panchayat Samiti";
    }
    if (role == 10) {
      formData.scheme = "zp";
      return "Zila Parishad";
    }
  };
  const handleFileNoChange = (e) => {
    // console.log(e.target.value);
    if (e.target.value != "") {
      setValidationState((prevState) => ({
        ...prevState,
        validationFileNo: true,
      }));
    } else {
      setValidationState((prevState) => ({
        ...prevState,
        validationFileNo: false,
      }));
    }
    const fileNo = e.target.value;
    setFileNo(fileNo);
    formData.file_no = e.target.value;
  };

  const handleInvoiceChange = (e) => {
    // console.log(e.target.value)
    if (e.target.value != "") {
      setValidationState((prevState) => ({
        ...prevState,
        validationInvoiceNo: true,
      }));
    } else {
      setValidationState((prevState) => ({
        ...prevState,
        validationInvoiceNo: false,
      }));
    }
    const invoice = e.target.value;
    setInvoice(invoice);
    formData.invoice_no = e.target.value;
  };

  const handleShow = () => {
    let random = parseInt(Math.floor(Math.random() * 1000000));
    setVoucher(`Voucher_${random}`);
    setShow((prevState) => !prevState);
    // setDSCModalShow(true);
  };
  const handleLimitChange = (e) => {
    debitDetails.vendorAmt = "";
    setIsLimitAmntVisible(true);
    if (e.target.value != "") {
      setValidationState((prevState) => ({
        ...prevState,
        validationUseLimit: true,
      }));
    } else {
      setValidationState((prevState) => ({
        ...prevState,
        validationUseLimit: false,
      }));
    }
    const limit = e.target.value;
    if (limit == "normal") {
      formData.limit_type = "normal";
      setLimitAmount(totalNormal - (totalNormalUsed + totalNormalPending));
    } else if (limit == "sccp") {
      formData.limit_type = "sccp";
      setLimitAmount(totalSccp - (totalSccpUsed + totalSccpPending));
    } else if (limit == "rid") {
      formData.limit_type = "rid";
      setLimitAmount(totalRid - (totalRidUsed + totalRidPending));
    }
  };

  const handleWorkTypes = async () => {
    try {
      await getWorkTypes(token).then((res) => {
        if (res.status === "success") {
          setWorkTypes(res.data);
        }
      });
    } catch (error) {}
  };
  const handleVenderName = (event) => {
    const selectedIndex =
      event.target.options[event.target.selectedIndex].getAttribute(
        "data-index"
      );
    setVenderName(venderData[selectedIndex].vendor_name);
    formData.vendor_name = venderData[selectedIndex].vendor_name;
  };
  const handelTypeofWorkName = (e) => {
    if (e.target.value != "") {
      setValidationState((prevState) => ({
        ...prevState,
        validationTypeofWork: true,
      }));
    } else {
      setValidationState((prevState) => ({
        ...prevState,
        validationTypeofWork: false,
      }));
    }

    const selectedIndex =
      e.target.options[e.target.selectedIndex].getAttribute("data-index");
    setWorkTypeName(workTypes[selectedIndex].work_type_name);
    setWorkTypeID(workTypes[selectedIndex].work_type_id);
    formData.work_id = workTypes[selectedIndex].work_type_id;
    formData.work_name = workTypes[selectedIndex].work_type_name;
  };

  const handleMinorHead = (e) => {
    if (e.target.value != "") {
      setValidationState((prevState) => ({
        ...prevState,
        validationMinorHead: true,
      }));
    } else {
      setValidationState((prevState) => ({
        ...prevState,
        validationMinorHead: true,
      }));
    }
    formData.minor_head = e.target.value;
    const selectedIndex =
      e.target.options[e.target.selectedIndex].getAttribute("data-index");
    // console.log(
    //   minorHeads.length > 0
    //     ? minorHeads[selectedIndex].nomenclature_of_minor_head
    //     : ""
    // );
    setMinorHeadName(
      minorHeads.length > 0
        ? `${minorHeads[selectedIndex].nomenclature_of_minor_head}-${minorHeads[selectedIndex].minor_head}`
        : ""
    );
  };

  const checkPDF = () => {
    const allValid = Object.values(validationState).every(
      (value) => value === true
    );
    if (allValid) {
      // console.log(true);
      formData.deduction_amount = debitDetails.deductionAmt;
      setDSCModalShow(true);
      // console.log(formData);

      exportPDF(formData);
    } else {
      MySwal.fire({
        icon: "warning",
        title: "Alert",
        text: "Please fill all the neccesory fields",
      });
      // console.log(false);
    }
  };
  const handleShowVenderPayment = (value) => {
    if (value == "true") {
      setSecurityChecked(false);
      setlcessChecked(false);
      setlfedChecked(false);
      setcgstChecked(false);
      setsgstChecked(false);
      setigstChecked(false);
      setitaxChecked(false);
      setSecurityValue("");
      setlcessValue("");
      setlfedValue("");
      setcgstValue("");
      setsgstValue("");
      setigstValue("");
      setitaxValue("");
      setShowDeduction(false);
      setShowVenderPayment(true);
    } else if (value == "false") {
      setShowVenderPayment(false);
      debitDetails.narration = "";
      setValidationState((prevState) => ({
        ...prevState,
        validationNarration: false,
      }));
    }
  };

  const [showPaymentConsentModal, setShowPaymentConsentModal] = useState(true);
  const hidePaymentConsentModal = () => setShowPaymentConsentModal(false);
  const handleVendorOnBlur = (e) => {
    const value = e.target.value;

    handleShowVenderPayment("true");
    setShowPaymentConsentModal(true);
  };

  const [isConsentChecked, setIsConsentChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsConsentChecked(e.target.checked);
  };

  return (
    <div>
      <form action="">
        <div id="loading-coupon" style={{ display: loading ? "flex" : "none" }}>
          <img id="loading-image" src={loader} alt="Loading..." />
        </div>
        <div
          id="loading-coupon2"
          style={{ display: loadingNew ? "flex" : "none" }}
        >
          <img id="loading-image2" src={loader} alt="Loading..." />
        </div>
        <div className="px-2 px-md-4">
          <div className="my-4 col-12 d-flex justify-content-between align-items-center">
            <h5 style={{ fontWeight: "bold" }}>
              Vendor Payment Creation Payable
            </h5>
          </div>

          <form className="filter " id="myform" onSubmit={handleChange}>
            <div className="row mb-4">
              <div className="col-4">
                <label htmlFor="type" className="form-label d-flex flex-col">
                  <h5 style={{ fontWeight: "bold" }}>Entity</h5>
                  {<span style={{ color: "red" }}>*</span>}{" "}
                </label>
                {role == 6 || role == 7 || role == 8 ? (
                  <input
                    name="type"
                    id="type"
                    className="form-control"
                    value={selectedValueName}
                    onChange={handleEntityChange}
                    disabled={isReadonlyEntity}
                    required
                  />
                ) : (
                  <select
                    name="type"
                    id="type"
                    className="type form-select"
                    value={selectedValue}
                    onChange={handleEntityChange}
                    disabled={isReadonlyEntity}
                  >
                    <option value="" disabled>
                      Select Type
                    </option>
                    {visibleOptions.includes("sab") && (
                      <option value="sab">All</option>
                    )}
                    {visibleOptions.includes("gp") && (
                      <option value="gp">Gram Panchayat</option>
                    )}
                    {visibleOptions.includes("ps") && (
                      <option value="ps">Panchayat Samiti</option>
                    )}
                    {visibleOptions.includes("zp") && (
                      <option value="zp">Zila Parishad</option>
                    )}
                    {visibleOptions.includes("zp") && (
                      <option value="zp">District</option>
                    )}
                  </select>
                )}
              </div>
            </div>

            <table
              className="table table-striped table-bordered justify-content-center align-items-center"
              aria-label="simple table"
            >
              <thead>
                <tr style={{ fontSize: "16px" }}>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                    }}
                  >
                    District {<span style={{ color: "red" }}>*</span>}
                  </th>
                  {role != 10 && (
                    <th
                      align="center"
                      style={{
                        whiteSpace: "nowrap",
                        backgroundColor: "#00bfff",
                      }}
                    >
                      Block {<span style={{ color: "red" }}>*</span>}
                    </th>
                  )}
                  {role != 10 && role != 8 && (
                    <th
                      align="center"
                      style={{
                        whiteSpace: "nowrap",
                        backgroundColor: "#00bfff",
                      }}
                    >
                      Gram Panchayat {<span style={{ color: "red" }}>*</span>}
                    </th>
                  )}
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                    }}
                  >
                    Financial Year
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                    }}
                  >
                    Quarter {<span style={{ color: "red" }}>*</span>}
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                    }}
                  >
                    Month {<span style={{ color: "red" }}>*</span>}
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                    }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ fontSize: "16px" }}>
                  <td component="th" scope="row">
                    {districtData.length == 1 ? (
                      <input
                        name="district"
                        className="form-control"
                        value={districtName}
                        onChange={handleDistrictChange}
                        disabled={isReadonlyDistrict}
                        required
                      />
                    ) : (
                      <select
                        name="district"
                        className="common-input form-select"
                        value={districtType}
                        onChange={handleDistrictChange}
                        //disabled={isReadonlyDistrict}
                        required
                      >
                        <option value="" disabled>
                          Select District
                        </option>
                        {(role === 1 ||
                          role === 2 ||
                          role === 3 ||
                          role === 4 ||
                          role === 19 ||
                          role === 20 ||
                          role === 22) && <option value="all">All</option>}

                       
{districtData
  .filter((district, index, self) => 
    index === self.findIndex(d => d.district_code === district.district_code)
  )
  .map((district, index) => (
    <option key={index} value={district.district_code}>
      {district.district_name}
    </option>
  ))}
                      </select>
                    )}
                  </td>
                  {role != 10 && (
                    <td component="th" scope="row">
                      {blockData.length == 1 ? (
                        <input
                          name="block"
                          className="form-control"
                          type="text"
                          value={blockData[0]?.block_name}
                          disabled={isReadonlyBlock}
                        />
                      ) : (
                        <select
                          name="block"
                          className="common-input form-select"
                          value={blockType}
                          onChange={handleBlockChange}
                          disabled={isReadonlyBlock}
                          required
                        >
                          <option value="" disabled>
                            {" "}
                            Select Block
                          </option>

                          {blockData.map((block, index) => (
                            <option key={index} value={block.block_code}>
                              {block.block_name}
                            </option>
                          ))}
                        </select>
                      )}
                    </td>
                  )}
                  {role != 10 && role != 8 && (
                    <td component="th" scope="row">
                      <select
                        name="village"
                        className="common-input form-select"
                        value={GPType}
                        onChange={handleGPChange}
                        required
                      >
                        <option value="" disabled>
                          Select Gram Panchayat
                        </option>

                        {GPData?.map((gp, index) => (
                          <option key={index} value={gp.VillageId}>
                            {gp.VillageName}
                          </option>
                        ))}
                      </select>
                    </td>
                  )}

                  <td component="th" scope="row">
                    <input
                      className="form-control"
                      name="fy"
                      value={fyType}
                      disabled
                    />
                  </td>
                  <td component="th" scope="row">
                    <input
                      type="text"
                      name="quarter"
                      className="form-control"
                      value={quarterAuto}
                      disabled
                    />
                  </td>
                  <td component="th" scope="row">
                    <input
                      type="text"
                      name="Month"
                      className="form-control"
                      value={quarterMonth}
                      disabled
                    />
                  </td>
                  <td component="th" scope="row">
                    <button
                      type="submit"
                      className="btn"
                      style={{ width: "8vw", marginBlockEnd: "4px" }}
                      onClick={handleCheckLimits}
                      disabled={ischeckLImits != true ? true : false}
                    >
                      Check Limits
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
          {isVisible && (
            <div>
              {paymenAllocatedtData && paymenAllocatedtData.length > 0 && (
                <div className="" style={{ overflowX: "auto" }}>
                  <div className="mt-4 col-12 d-flex justify-content-between align-items-center">
                    <h5 style={{ fontWeight: "bold" }}>Allocation</h5>
                  </div>

                  <TableContainer
                    className="table table-striped table-bordered justify-content-center align-items-center"
                    aria-label="simple table"
                  >
                    <Table>
                      <TableHead>
                        <TableRow style={{ fontSize: "16px" }}>
                          <TableCell
                            align="center"
                            style={{
                              ...cellStyle,
                              backgroundColor: "#00bfff",
                              width: "16.66%",
                            }}
                          >
                            FY
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              ...cellStyle,
                              backgroundColor: "#00bfff",
                              width: "16.66%",
                            }}
                          >
                            Quarter
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              ...cellStyle,
                              backgroundColor: "#00bfff",
                              width: "16.66%",
                            }}
                          >
                            Normal
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              ...cellStyle,
                              backgroundColor: "#00bfff",
                              width: "16.66%",
                            }}
                          >
                            SCCP
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              ...cellStyle,
                              width: "16.66%",
                              backgroundColor: "#00bfff",
                            }}
                          >
                            RID
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ ...cellStyle, backgroundColor: "#00bfff" }}
                          >
                            Total
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody style={{ color: "white" }}>
                        {paymenAllocatedtData?.map((row, index) => (
                          <TableRow key={index} style={{ fontSize: "16px" }}>
                            <TableCell
                              component="th"
                              scope="row"
                              style={cellStyle}
                            >
                              {row.FY}
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              {row.quarter}
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              {row.normal}
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              {row.sccp}
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              {row.rid}
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              {row.normal + row.sccp + row.rid}
                            </TableCell>
                          </TableRow>
                        ))}
                        <TableRow style={{ fontSize: "16px" }}>
                          <TableCell
                            component="th"
                            scope="row"
                            align="center"
                            style={{ ...cellStyle, backgroundColor: "#FF0000" }}
                          >
                            Total Allocated
                          </TableCell>
                          <TableCell
                            style={cellStyle}
                            align="center"
                          ></TableCell>
                          <TableCell style={cellStyle} align="center">
                            {totalNormal}
                          </TableCell>
                          <TableCell style={cellStyle} align="center">
                            {totalSccp}
                          </TableCell>
                          <TableCell style={cellStyle} align="center">
                            {totalRid}
                          </TableCell>
                          <TableCell style={cellStyle} align="center">
                            {totalAllocated}
                          </TableCell>
                        </TableRow>
                        {paymentUsedData?.map((row, index) => (
                          <TableRow key={index} style={{ fontSize: "16px" }}>
                            <TableCell
                              component="th"
                              scope="row"
                              align="center"
                              style={{
                                ...cellStyle,
                                backgroundColor: "#FFFF00",
                              }}
                            >
                              Total Usage
                            </TableCell>
                            <TableCell
                              style={cellStyle}
                              align="center"
                            ></TableCell>
                            <TableCell style={cellStyle} align="center">
                              {totalNormalUsed}
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              {totalSccpUsed}
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              {totalRidUsed}
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              {totalUsed}
                            </TableCell>
                          </TableRow>
                        ))}
                        {paymentPendingData?.map((row, index) => (
                          <TableRow key={index} style={{ fontSize: "16px" }}>
                            <TableCell
                              component="th"
                              scope="row"
                              align="center"
                              style={{
                                ...cellStyle,
                                backgroundColor: "#FFFF00",
                              }}
                            >
                              Total Pending
                            </TableCell>
                            <TableCell
                              style={cellStyle}
                              align="center"
                            ></TableCell>
                            <TableCell style={cellStyle} align="center">
                              {totalNormalPending}
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              {totalSccpPending}
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              {totalRidPending}
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              {totalPending}
                            </TableCell>
                          </TableRow>
                        ))}
                        <TableRow style={{ fontSize: "16px" }}>
                          <TableCell
                            component="th"
                            scope="row"
                            align="center"
                            style={{ ...cellStyle, backgroundColor: "#48ab51" }}
                          >
                            Total Available
                          </TableCell>
                          <TableCell
                            style={cellStyle}
                            align="center"
                          ></TableCell>
                          <TableCell style={cellStyle} align="center">
                            {totalNormal -
                              (totalNormalUsed + totalNormalPending)}
                          </TableCell>
                          <TableCell style={cellStyle} align="center">
                            {totalSccp - (totalSccpUsed + totalSccpPending)}
                          </TableCell>
                          <TableCell style={cellStyle} align="center">
                            {totalRid - (totalRidUsed + totalRidPending)}
                          </TableCell>
                          <TableCell style={cellStyle} align="center">
                            {totalAllocated - (totalUsed + totalPending)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}

              {totalAmount > 0 && (
                <div>
                  <div className="my-4">
                    <table
                      className="table table-striped table-bordered justify-content-center align-items-center"
                      aria-label="simple table"
                    >
                      <thead>
                        <tr style={{ fontSize: "16px" }}>
                          <th
                            align="center"
                            style={{
                              whiteSpace: "nowrap",
                              backgroundColor: "#00bfff",
                              width: "33%",
                            }}
                          >
                            Type of Head{" "}
                            {<span style={{ color: "red" }}>*</span>}
                          </th>
                          <th
                            align="center"
                            style={{
                              whiteSpace: "nowrap",
                              backgroundColor: "#00bfff",
                              width: "33%",
                            }}
                          >
                            Major Heads{" "}
                            {<span style={{ color: "red" }}>*</span>}{" "}
                          </th>
                          <th
                            align="center"
                            style={{
                              whiteSpace: "nowrap",
                              backgroundColor: "#00bfff",
                              width: "33%",
                            }}
                          >
                            Minor Heads{" "}
                            {<span style={{ color: "red" }}>*</span>}{" "}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ fontSize: "16px" }}>
                          <td component="th" scope="row">
                            <input
                              name="Month"
                              className="common-input form-select"
                              value="Payable"
                              required
                              disabled
                            />
                          </td>
                          <td component="th" scope="row">
                            <select
                              name="majorHead"
                              className="common-input form-select"
                              required
                              onChange={handleMajorHead}
                            >
                              <option value="" selected disabled>
                                Select Major Head
                              </option>
                              {majorHeads.length > 0 ? (
                                majorHeads.map((head, index) => (
                                  <option
                                    key={index}
                                    value={head.major_head}
                                    data-index={index}
                                  >
                                    {`${head.nomenclature_of_major_head}-${head.major_head}`}
                                  </option>
                                ))
                              ) : (
                                <option disabled>No Data Available</option>
                              )}
                            </select>
                          </td>
                          <td component="th" scope="row">
                            <select
                              name="Month"
                              className="common-input form-select"
                              required
                              onChange={handleMinorHead}
                            >
                              <option value="" selected disabled>
                                Select Minor Heads
                              </option>
                              {minorHeads.length > 0 ? (
                                minorHeads.map((head, index) => (
                                  <option
                                    key={index}
                                    value={head.minor_head}
                                    data-index={index}
                                  >
                                    {`${head.nomenclature_of_minor_head}-${head.minor_head}`}
                                  </option>
                                ))
                              ) : (
                                <option disabled>No Data Available</option>
                              )}
                            </select>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="">
                    <div className="mt-4 col-12 d-flex justify-content-between align-items-center">
                      <h5 style={{ fontWeight: "bold" }}>Debit Details</h5>
                    </div>
                    <table
                      className="table table-striped table-bordered justify-content-center align-items-center"
                      aria-label="simple table"
                    >
                      <thead>
                        <tr style={{ fontSize: "16px" }}>
                          <th
                            align="center"
                            style={{
                              whiteSpace: "nowrap",
                              backgroundColor: "#00bfff",
                            }}
                          >
                            Use of Limit{" "}
                            {<span style={{ color: "red" }}>*</span>}{" "}
                          </th>
                          <th
                            align="center"
                            style={{
                              whiteSpace: "nowrap",
                              backgroundColor: "#00bfff",
                            }}
                          >
                            Type of Work{" "}
                            {<span style={{ color: "red" }}>*</span>}{" "}
                          </th>
                          <th
                            align="center"
                            style={{
                              whiteSpace: "nowrap",
                              backgroundColor: "#00bfff",
                            }}
                          >
                            Vendor Amount{" "}
                            {<span style={{ color: "red" }}>*</span>}{" "}
                          </th>
                          <th
                            align="center"
                            style={{
                              whiteSpace: "nowrap",
                              backgroundColor: "#00bfff",
                            }}
                          >
                            Narration {<span style={{ color: "red" }}>*</span>}{" "}
                          </th>
                          <th
                            align="center"
                            style={{
                              whiteSpace: "nowrap",
                              backgroundColor: "#00bfff",
                            }}
                          >
                            Remaining Bal.
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ fontSize: "16px" }}>
                          <td style={{ whiteSpace: "nowrap" }} align="center">
                            <select
                              name="limit"
                              className="common-input form-select"
                              onChange={handleLimitChange}
                            >
                              <option value="" selected disabled>
                                Select Limit
                              </option>
                              <option value="normal">Normal</option>
                              <option value="sccp">SCCP</option>
                              <option value="rid">RID</option>
                            </select>
                          </td>
                          <td style={{ whiteSpace: "nowrap" }} align="center">
                            <select
                              name="typeofwork"
                              className="common-input form-select"
                              onChange={handelTypeofWorkName}
                            >
                              <option value="" selected disabled>
                                Select Work
                              </option>
                              {workTypes.length > 0 ? (
                                workTypes.map((work, index) => (
                                  <option
                                    value={work.work_type_id}
                                    key={index}
                                    data-index={index}
                                  >
                                    {work.work_type_name}
                                  </option>
                                ))
                              ) : (
                                <option>No Data Available</option>
                              )}
                            </select>
                          </td>
                          <td style={{ whiteSpace: "nowrap" }} align="center">
                            <input
                              type="text"
                              className="form-control"
                              value={debitDetails.vendorAmt}
                              onChange={(e) => {
                                const value = e.target.value;
                                const regex = /^[1-9]\d*$/;
                                if (value === "" || regex.test(value)) {
                                  handleVendorAmtChange(e);
                                }
                              }}
                              onBlur={(e) => {
                                if (totalAmount > 0) {
                                  handleVendorOnBlur(e);
                                }
                              }}
                              onFocus={() => handleShowVenderPayment("false")}
                              disabled={!isVisible}
                            />
                          </td>
                          <td style={{ whiteSpace: "nowrap" }} align="center">
                            <input
                              type="text"
                              className="form-control"
                              value={debitDetails.narration}
                              onChange={handleNarrationChange}
                            />
                          </td>
                          <td style={{ whiteSpace: "nowrap" }} align="center">
                            {limitAmount -
                              (debitDetails.vendorAmt -
                                debitDetails.deductionAmt)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {ShowVenderPayment && (
                    <div>
                      <div className="">
                        <div className="mt-4">
                          <h5 style={{ fontWeight: "bold", textAlign: "left" }}>
                            Vendor/Beneficiary Payment
                          </h5>
                        </div>

                        <table
                          className="table table-striped table-bordered justify-content-center align-items-center"
                          aria-label="simple table"
                        >
                          <thead>
                            <tr style={{ fontSize: "16px" }}>
                              <th
                                align="center"
                                style={{
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#00bfff",
                                }}
                              >
                                Entry Date
                              </th>
                              <th
                                align="center"
                                style={{
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#00bfff",
                                }}
                              >
                                Posting Date{" "}
                                {<span style={{ color: "red" }}>*</span>}{" "}
                              </th>
                              <th
                                align="center"
                                style={{
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#00bfff",
                                }}
                              >
                                Scheme
                              </th>
                              <th
                                align="center"
                                style={{
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#00bfff",
                                }}
                              >
                                Deduction Applied
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr style={{ fontSize: "16px" }}>
                              <td component="th" scope="row">
                                <input
                                  className="form-control"
                                  name="processing_date"
                                  value={processingDate}
                                  disabled
                                />
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                align="center"
                              >
                                <input
                                  type="date"
                                  className="form-control"
                                  name="posting_date"
                                  max={new Date().toISOString().split("T")[0]}
                                  value={postingDate}
                                  onChange={handlePostingDate}
                                />
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                align="center"
                              >
                                <input
                                  className="form-control"
                                  value={schemeName}
                                  disabled
                                />
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                align="center"
                              >
                                <select
                                  name="deduction_applied"
                                  className="common-input form-select"
                                  onChange={handleDeductionChange}
                                >
                                  <option value="0">Select Deduction</option>
                                  <option value="No">No</option>
                                  <option value="Yes">Yes</option>
                                </select>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {showDeduction && (
                        <div className="">
                          <div className="mt-4 col-md-12 d-flex justify-content-between align-items-center">
                            <h5 style={{ fontWeight: "bold" }}>
                              Deduction is as under
                            </h5>
                          </div>
                          <table
                            className="table table-striped table-bordered justify-content-center align-items-center"
                            aria-label="simple table"
                          >
                            <thead>
                              <tr style={{ fontSize: "16px" }}>
                                <th
                                  align="center"
                                  style={{
                                    whiteSpace: "nowrap",
                                    backgroundColor: "#00bfff",
                                  }}
                                >
                                  <div className="d-flex col justify-content-between">
                                    <div className="d-flex col">
                                      <input
                                        type="checkbox"
                                        className="form-check-input me-1"
                                        onChange={handleSecurityCheckboxChange}
                                      />
                                      <label className="form-label">
                                        Security
                                      </label>
                                    </div>
                                    <input
                                      type="text"
                                      value={securityTax}
                                      disabled
                                      style={{
                                        border: "1px solid grey",
                                        fontSize: "12px",
                                        padding: "4px",
                                        width: "25px",
                                        visibility: !securityChecked
                                          ? "hidden"
                                          : "",
                                      }}
                                    />
                                  </div>
                                </th>
                                <th
                                  align="center"
                                  style={{
                                    whiteSpace: "nowrap",
                                    backgroundColor: "#00bfff",
                                  }}
                                >
                                  <div className="d-flex col justify-content-between">
                                    <div className="d-flex col">
                                      <input
                                        type="checkbox"
                                        className="form-check-input me-1"
                                        onChange={handlelcessCheckboxChange}
                                      />
                                      <label className="form-label">
                                        L.Cess
                                      </label>
                                    </div>
                                    <input
                                      type="text"
                                      value={lCessTax}
                                      disabled
                                      style={{
                                        border: "1px solid grey",
                                        fontSize: "12px",
                                        padding: "4px",
                                        width: "25px",
                                        visibility: !lcessChacked
                                          ? "hidden"
                                          : "",
                                      }}
                                    />
                                  </div>
                                </th>
                                <th
                                  align="center"
                                  style={{
                                    whiteSpace: "nowrap",
                                    backgroundColor: "#00bfff",
                                  }}
                                >
                                  <div className="d-flex col justify-content-between">
                                    <div className="d-flex col">
                                      <input
                                        type="checkbox"
                                        className="form-check-input me-1"
                                        onChange={handlelfedCheckboxChange}
                                      />
                                      <label className="form-label">
                                        L.FedCess
                                      </label>
                                    </div>
                                    <input
                                      type="text"
                                      value={lFedCessTax}
                                      disabled
                                      style={{
                                        border: "1px solid grey",
                                        fontSize: "12px",
                                        padding: "4px",
                                        width: "25px",
                                        visibility: !lfedChacked
                                          ? "hidden"
                                          : "",
                                      }}
                                    />
                                  </div>
                                </th>
                                <th
                                  align="center"
                                  style={{
                                    whiteSpace: "nowrap",
                                    backgroundColor: "#00bfff",
                                  }}
                                >
                                  <div className="d-flex col justify-content-between">
                                    <div className="d-flex col">
                                      <input
                                        type="checkbox"
                                        className="form-check-input me-1"
                                        onChange={handlecgstCheckboxChange}
                                        disabled={CGST == false}
                                      />
                                      <label className="form-label">CGST</label>
                                    </div>
                                    <input
                                      type="text"
                                      value={cgstTax}
                                      disabled
                                      style={{
                                        border: "1px solid grey",
                                        fontSize: "12px",
                                        padding: "4px",
                                        width: "25px",
                                        visibility: !cgstChacked
                                          ? "hidden"
                                          : "",
                                      }}
                                    />
                                  </div>
                                </th>
                                <th
                                  align="center"
                                  style={{
                                    whiteSpace: "nowrap",
                                    backgroundColor: "#00bfff",
                                  }}
                                >
                                  <div className="d-flex col justify-content-between">
                                    <div className="d-flex col">
                                      <input
                                        type="checkbox"
                                        className="form-check-input me-1"
                                        onChange={handlesgstCheckboxChange}
                                        disabled={SGST == false}
                                      />
                                      <label className="form-label">SGST</label>
                                    </div>
                                    <input
                                      type="text"
                                      value={sgstTax}
                                      disabled
                                      style={{
                                        border: "1px solid grey",
                                        fontSize: "12px",
                                        padding: "4px",
                                        width: "25px",
                                        visibility: !sgstChacked
                                          ? "hidden"
                                          : "",
                                      }}
                                    />
                                  </div>
                                </th>
                                <th
                                  align="center"
                                  style={{
                                    whiteSpace: "nowrap",
                                    backgroundColor: "#00bfff",
                                  }}
                                >
                                  <div className="d-flex col justify-content-between">
                                    <div className="d-flex col">
                                      <input
                                        type="checkbox"
                                        className="form-check-input me-1"
                                        onChange={handleigstCheckboxChange}
                                        disabled={IGST == false}
                                      />
                                      <label className="form-label">IGST</label>
                                    </div>
                                    <input
                                      type="text"
                                      value={igstTax}
                                      disabled
                                      style={{
                                        border: "1px solid grey",
                                        fontSize: "12px",
                                        padding: "4px",
                                        width: "25px",
                                        visibility: !igstChacked
                                          ? "hidden"
                                          : "",
                                      }}
                                    />
                                  </div>
                                </th>
                                <th
                                  align="center"
                                  style={{
                                    whiteSpace: "nowrap",
                                    backgroundColor: "#00bfff",
                                  }}
                                >
                                  <div className="d-flex col justify-content-between">
                                    <div className="d-flex col">
                                      <input
                                        type="checkbox"
                                        className="form-check-input me-1"
                                        onChange={handleitaxCheckboxChange}
                                      />
                                      <label className="form-label">
                                        I.tax
                                      </label>
                                    </div>
                                    <input
                                      type="text"
                                      value={itaxValue}
                                      disabled
                                      style={{
                                        border: "1px solid grey",
                                        fontSize: "12px",
                                        padding: "4px",
                                        width: "25px",
                                        visibility: !itaxChacked
                                          ? "hidden"
                                          : "",
                                      }}
                                    />
                                  </div>
                                </th>
                                <th
                                  align="center"
                                  style={{
                                    whiteSpace: "nowrap",
                                    backgroundColor: "#00bfff",
                                  }}
                                  className="justify-content-center"
                                >
                                  <div>Calculate Deduction</div>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr style={{ fontSize: "16px" }}>
                                <td component="th" scope="row">
                                  <input
                                    className="form-control"
                                    value={securityChecked ? securityValue : 0}
                                    disabled={!securityChecked}
                                  />
                                </td>
                                <td
                                  style={{ whiteSpace: "nowrap" }}
                                  align="center"
                                >
                                  <input
                                    className="form-control"
                                    value={lcessChacked ? lcessValue : 0}
                                    disabled={!lcessChacked}
                                  />
                                </td>
                                <td
                                  style={{ whiteSpace: "nowrap" }}
                                  align="center"
                                >
                                  <input
                                    className="form-control"
                                    value={lfedChacked ? lfedValue : 0}
                                    disabled={!lfedChacked}
                                  />
                                </td>
                                <td
                                  style={{ whiteSpace: "nowrap" }}
                                  align="center"
                                >
                                  <input
                                    className="form-control"
                                    value={cgstChacked ? cgstValue : 0}
                                    disabled={!cgstChacked}
                                  />
                                </td>
                                <td
                                  style={{ whiteSpace: "nowrap" }}
                                  align="center"
                                >
                                  <input
                                    className="form-control"
                                    value={sgstChacked ? sgstValue : 0}
                                    disabled={!sgstChacked}
                                  />
                                </td>
                                <td
                                  style={{ whiteSpace: "nowrap" }}
                                  align="center"
                                >
                                  <input
                                    className="form-control"
                                    value={igstChacked ? igstValue : 0}
                                    disabled={!igstChacked}
                                  />
                                </td>
                                <td
                                  style={{ whiteSpace: "nowrap" }}
                                  align="center"
                                >
                                  <input
                                    className="form-control"
                                    value={itaxChacked ? itaxValue : 0}
                                    disabled={!itaxChacked}
                                  />
                                </td>
                                <td className="justify-content-center">
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={handleCalulateDeduction}
                                  >
                                    Calculate
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}

                  {cardDetails && (
                    <div>
                      <div className="">
                        <div className="mt-4 col-12 d-flex justify-content-between align-items-center">
                          <h5 style={{ fontWeight: "bold" }}>Credit Details</h5>
                        </div>
                        <table
                          className="table table-striped table-bordered justify-content-center align-items-center"
                          aria-label="simple table"
                        >
                          <thead>
                            <tr style={{ fontSize: "16px" }}>
                              <th
                                align="center"
                                style={{
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#00bfff",
                                }}
                              >
                                Vendor {<span style={{ color: "red" }}>*</span>}{" "}
                              </th>
                              <th
                                align="center"
                                style={{
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#00bfff",
                                }}
                              >
                                Build Amount
                              </th>
                              <th
                                align="center"
                                style={{
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#00bfff",
                                }}
                              >
                                Deduction Amount
                              </th>
                              <th
                                align="center"
                                style={{
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#00bfff",
                                }}
                              >
                                Payable to Vender
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr style={{ fontSize: "16px" }}>
                              <td component="th" scope="row">
                                <select
                                  name="vendorName"
                                  className="form-select form-select-sm"
                                  onChange={(e) =>
                                    handleVendorChange(
                                      e,
                                      debitDetails.deductionAmt
                                    )
                                  }
                                >
                                  <option selected disabled>
                                    Select Vendor
                                  </option>
                                  {venderData?.map((data, index) => (
                                    <option
                                      value={data.vendor_id}
                                      data-index={index}
                                    >
                                      {data.vendor_name}
                                    </option>
                                  ))}
                                </select>
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                align="center"
                              >
                                {" "}
                                {debitDetails.vendorAmt}
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                align="center"
                              >
                                {debitDetails.deductionAmt}
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                align="center"
                              >
                                {debitDetails.total
                                  ? debitDetails.vendorAmt -
                                    debitDetails.deductionAmt
                                  : 0}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div className="mt-4">
                        <table
                          className="table table-striped table-bordered justify-content-center align-items-center"
                          aria-label="simple table"
                        >
                          <thead>
                            <tr style={{ fontSize: "16px" }}>
                              <th
                                align="center"
                                style={{
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#00bfff",
                                }}
                              >
                                File No.{" "}
                                {<span style={{ color: "red" }}>*</span>}{" "}
                              </th>
                              <th
                                align="center"
                                style={{
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#00bfff",
                                }}
                              >
                                Approval Date
                              </th>
                              <th
                                align="center"
                                style={{
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#00bfff",
                                }}
                              >
                                Invoice No.{" "}
                                {<span style={{ color: "red" }}>*</span>}{" "}
                              </th>
                              <th
                                align="center"
                                style={{
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#00bfff",
                                }}
                              >
                                Invoice Date
                              </th>
                              <th
                                align="center"
                                style={{
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#00bfff",
                                }}
                              >
                                Upload Voucher{" "}
                                {<span style={{ color: "red" }}>*</span>}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr style={{ fontSize: "16px" }}>
                              <td component="th" scope="row">
                                <input
                                  className="form-control"
                                  type="text"
                                  name="file_no"
                                  value={fileNo}
                                  onChange={handleFileNoChange}
                                />
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                align="center"
                              >
                                <input
                                  className="form-control"
                                  value={approvalDate}
                                  disabled
                                />
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                align="center"
                              >
                                <input
                                  className="form-control"
                                  value={invoice}
                                  onChange={handleInvoiceChange}
                                />
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                align="center"
                              >
                                <input
                                  className="form-control"
                                  defaultValue={new Date()
                                    .toISOString()
                                    .substr(0, 10)}
                                  disabled
                                />
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                align="center"
                              >
                                <input
                                  type="file"
                                  className="form-control"
                                  onChange={handleFile}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  <div className="row col-12 mt-5 d-flex mx-1 mb-5 justify-content-end">
                    <button
                      type="button"
                      className="btn me-2 col-md-2"
                      // onClick={handleShow}
                      onClick={checkPDF}
                      disabled={isConsentChecked == true ? false : true}
                    >
                      Preview
                    </button>
                    <Modal show={show} onHide={handleClose} size="xl">
                      <Modal.Header closeButton>
                        <Modal.Title>Payment Voucher</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Container>
                          <h5></h5>
                          <Table bordered className="custom-table">
                            <tbody>
                              <tr>
                                <td>Type of Transaction</td>
                                <td>Online</td>
                              </tr>
                              <tr>
                                <td>Scheme Name</td>
                                <td>{schemeName}</td>
                              </tr>
                              <tr>
                                <td>Work Type</td>
                                <td>{workTypeName}</td>
                              </tr>
                              <tr>
                                <td>Sanctioned Amount</td>
                                <td>{limitAmount}</td>
                              </tr>
                              <tr>
                                <td>DNIT/Agreement Amount</td>
                                <td>{debitDetails.vendorAmt}</td>
                              </tr>
                              <tr>
                                <td>Voucher No</td>
                                <td>{voucher}</td>
                              </tr>
                              <tr>
                                <td>Expenditure Major Head</td>
                                <td>{majorHeadName}</td>
                              </tr>
                              <tr>
                                <td>Expenditure Minor Head</td>
                                <td>{minorHeadName}</td>
                              </tr>
                              <tr>
                                <td>To whom Paid (Vendor Name)</td>
                                <td>{venderName}</td>
                              </tr>
                              <tr>
                                <td>Remarks</td>
                                <td>{creditDetails.narration}</td>
                              </tr>
                              <tr>
                                <td>Mode of Payment</td>
                                <td>
                                  {vendorDetails[0]?.ifsc_code.slice(0, 4) ==
                                  "INDB"
                                    ? "IFTO"
                                    : "NEFT"}
                                </td>
                              </tr>
                              <tr>
                                <td>Payee Account Number</td>
                                <td>{vendorDetails[0]?.account_number}</td>
                              </tr>
                            </tbody>
                          </Table>
                          <br />
                          <h5>
                            Total Bill Amount :-{" "}
                            {debitDetails.vendorAmt
                              ? debitDetails.vendorAmt
                              : "0"}
                          </h5>
                          <br />
                          <Table bordered className="custom-table">
                            <tbody>
                              <tr>
                                <td>Deduction is as under:</td>
                                <td>&nbsp;</td>
                              </tr>
                              <tr>
                                <td>Security Rs.</td>
                                <td>{securityValue}</td>
                              </tr>
                              <tr>
                                <td>Income Tax Rs.</td>
                                <td>{itaxValue}</td>
                              </tr>
                              <tr>
                                <td>Labor Cess Rs</td>
                                <td>{lcessValue}</td>
                              </tr>
                              <tr>
                                <td>Labor Fed Cess Rs.</td>
                                <td>{lfedValue}</td>
                              </tr>
                              <tr>
                                <td>CGST Rs.</td>
                                <td>{cgstValue}</td>
                              </tr>
                              <tr>
                                <td>SGST Rs</td>
                                <td>{sgstValue}</td>
                              </tr>
                              <tr>
                                <td>IGST Rs.</td>
                                <td>{igstValue}</td>
                              </tr>
                              <tr>
                                <td>Total Deduction</td>
                                <td>{debitDetails.deductionAmt}</td>
                              </tr>
                            </tbody>
                          </Table>
                          <br />
                          <h5>
                            Net Pay to Vendor = (
                            {debitDetails.vendorAmt
                              ? debitDetails.vendorAmt
                              : 0}{" "}
                            -{" "}
                            {debitDetails.deductionAmt
                              ? debitDetails.deductionAmt
                              : 0}
                            ) =
                            {
                              (formData.remaining_balance =
                                debitDetails?.vendorAmt -
                                debitDetails?.deductionAmt)
                            }
                            {/* {
                        (formData.remaining_balance =
                          "")
                      } */}
                            {/* {console.log("oh yeah",totalDeductions,securityValue,itaxValue,lcessValue,lfedValue,cgstValue,sgstValue,igstValue)} */}
                          </h5>
                          <br />
                          <Table bordered className="custom-table">
                            <tbody>
                              <tr>
                                <td>
                                  Pay Rs.{" "}
                                  <strong>{formData.remaining_balance}</strong>{" "}
                                  by voucher No.
                                  <strong>{voucher ? voucher : " 0 "}</strong>
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="2">
                                  <strong>
                                    Dated:{" "}
                                    {new Date().toISOString().substr(0, 10)}
                                  </strong>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                          <br />
                          <Table bordered>
                            <tbody>
                              <tr>
                                <td colSpan="2"></td>
                              </tr>
                            </tbody>
                          </Table>
                          <br />
                        </Container>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          className="btn"
                          disabled={isSignPdfDisabled}
                          onClick={handleSubmit}
                          style={{ border: "black" }}
                        >
                          Sign Pdf
                        </Button>
                        <Button
                          variant="success"
                          onClick={handleSub}
                          disabled={isSubmitDisabled}
                        >
                          Submit
                        </Button>

                        <Button variant="secondary" onClick={handleClose}>
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>

                    <Modal
                      show={DSCModalShow}
                      onHide={handleDSCClose}
                      size="xl"
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>DSC validation</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Container>
                          <DSCValidationPage
                            Type={"VenderPaymentCreation"}
                            modal={handleShow}
                            close={handleDSCClose}
                            userData={userData}
                            token={token}
                            userDetail={userDetail}
                          />
                        </Container>
                      </Modal.Body>
                    </Modal>
                    <Modal
                      show={showPaymentConsentModal}
                      onHide={hidePaymentConsentModal}
                      size="l"
                      centered
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header>
                        <Modal.Title>Payment Consent</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Container>
                          <div>
                            {/* <h4>
                            The payment amount should match the vendor's request{" "}
                            <br />
                            (भुगतान की राशि विक्रेता के अनुरोध के अनुसार होनी
                            चाहिए)
                          </h4> */}
                            <div
                              className="d-flex"
                              style={{ alignItems: "baseline" }}
                            >
                              <input
                                type="checkbox"
                                name="consent"
                                checked={isConsentChecked}
                                onChange={handleCheckboxChange}
                              />
                              <label htmlFor="consent">
                                {" "}
                                &nbsp; I hereby declare that the amount I have
                                entered matches the vendor's request. If there
                                is any discrepancy in the amount, I will be
                                solely responsible for it. (मैं यह घोषणा
                                करता/करती हूं कि मैंने जो राशि भरी है, वह
                                विक्रेता के अनुरोध के अनुसार है। यदि राशि में
                                कोई अंतर होगा, तो उसकी पूरी जिम्मेदारी मेरी
                                होगी।)
                              </label>
                            </div>
                            <div className="d-flex justify-content-end mt-3">
                              <button
                                type="button"
                                disabled={
                                  isConsentChecked == true ? false : true
                                }
                                className="btn btn-secondary me-2 col-md-2 "
                                onClick={() =>
                                  setShowPaymentConsentModal(false)
                                }
                              >
                                Next
                              </button>
                            </div>
                          </div>{" "}
                        </Container>
                      </Modal.Body>
                    </Modal>
                    <button
                      type="button"
                      className="btn btn-secondary me-2 col-md-2"
                      onClick={() => window.location.reload()}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default VenderPaymentCreation;
